import { defineComponent } from 'vue'
import type { PropType } from 'vue'
import type { IBlockPage } from '@/types/mainPage'

export default defineComponent({
  name: 'HomeInfoPage',
  props: {
    page: {
      type: Object as PropType<IBlockPage>,
      required: true,
    },
  },
  emits: ['edit', 'toggleIsActive', 'delete'],
  setup() {
    return {}
  },
})
